import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    Cart,
    CreateCartInput,
    DeleteCartInput,
    UpdateCartInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private amplifyClient = generateClient();

    constructor() {}

    async listCarts(): Promise<Cart[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listCarts
                })
            ).data.listCarts.items;
            if (data) return data as Cart[];
        } catch (error) {
            console.error('Error finding listCarts:', error);
            return null;
        }
    }

    async getCart(id: string): Promise<Cart> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getCart,
                    variables: {
                        id
                    }
                })
            ).data.getCart;
            if (data) return data as Cart;
        } catch (error) {
            console.error('Error finding Clients:', error);
            return null;
        }
    }

    async updateCart(input: UpdateCartInput): Promise<Cart> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateCart,
                    variables: {
                        input
                    }
                })
            ).data.updateCart;
            if (data) return data as Cart;
        } catch (error) {
            console.error('Error updating Cart:', error);
            return null;
        }
    }

    async deleteCart(body: DeleteCartInput): Promise<Cart> {
        try {
            const response = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteCart,
                    variables: {
                        input: body
                    }
                })
            ).data.deleteCart;
            if (response) return response as Cart;
        } catch (error) {
            console.error('Error updating premium Cart:', error);
            return null;
        }
    }

    async createCart(input: CreateCartInput): Promise<Cart> {
        try {
            const category = (
                await this.amplifyClient.graphql({
                    query: mutations.createCart,
                    variables: {
                        input
                    }
                })
            ).data.createCart;
            if (category) return category as Cart;
        } catch (error) {
            console.error('Error creating Cart:', error);
            return null;
        }
    }
}
